import { actions } from './action'

const initialState = {
  loading: false,
  rules: [],
  totalCount: 0,
  meta: {
    shifts: [],
  },
  pagination: {
    current: 1,
    pageSize: 10,
  },
  filters: {
    search: '',
    ruleType: undefined,
    isActive: 1,
  },
}

const rotationRules = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case actions.SET_RULES:
      return {
        ...state,
        rules: action.payload.rules,
        totalCount: action.payload.totalCount,
      }
    case actions.SET_META:
      return {
        ...state,
        meta: action.payload,
      }
    case actions.SET_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload,
        },
      }
    case actions.SET_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      }
    case actions.RESET_FILTERS:
      return {
        ...state,
        filters: initialState.filters,
        pagination: initialState.pagination,
      }
    default:
      return state
  }
}

export default rotationRules
